export class jobModuleConfig {
  jobDetails : Function;
  tabName : string;
  source: any;

  constructor(jobDetails : Function){
      this.jobDetails = jobDetails;
  }

}
